module.exports = __webpack_public_path__ + "static/media/BICI.0d48ae75.svg";